import type { EntityAdminRecord } from '../../../types';
import type { DividerDrawerOption, InputsAndDropdownsDrawerOption } from '../types';

export const isOptionDivider = <TDrawerRecord extends EntityAdminRecord>(
  option: InputsAndDropdownsDrawerOption<TDrawerRecord>
): option is DividerDrawerOption<TDrawerRecord> => option.type === 'divider';

export type NonDividerDrawerOption<TDrawerRecord extends EntityAdminRecord> = Exclude<
  InputsAndDropdownsDrawerOption<TDrawerRecord>,
  DividerDrawerOption<TDrawerRecord>
>;
// Better typescript narrowing for the option type (can be removed if TS evolves to handle !isOptionDivider filtering properly)
export const isNotDivider = <TDrawerRecord extends EntityAdminRecord>(
  opt: InputsAndDropdownsDrawerOption<TDrawerRecord>
): opt is NonDividerDrawerOption<TDrawerRecord> => opt.type !== 'divider';
